/* 订单状态  */
export function handleOrderState(state, colorType) {
  const textObj = {
    unpaid: '待付款',
    paid: '待审核',
    delivered: '交付中',
    fulfill: ' 已完成',
    closed: '已关闭',
    reviewed: '待交付',
    abnormal: '异常',
    release: '已释放',
    released: '已释放',
    stopping: '关闭中',
    upgrade: '升级中',
    failure: '交付失败',
    undeploy: '未部署'
  };
  const colorObj = {
    unpaid: '#F00000',
    abnormal: '#F00000',
    fulfill: '#009900',
    upgrade: '#009900',
    closed: '#606266'
  };
  if (colorType) {
    return colorObj[state] || '#606266';
  }

  return textObj[state] || state;
}
export function fetchAppState(state, colorType) {
  const textObj = {
    expired: '已过期',
    preparing: '准备中',
    serving: '服务中'
  };

  const custom = colorType && colorType === 'time' ? '#606266' : '#009900';
  const colorObj = {
    preparing: '#009900',
    serving: custom,
    expired: '#F00000'
  };
  if (colorType) {
    return colorObj[state] || '#606266';
  }
  return textObj[state] || state;
}

export function handleAppState(state, colorType) {
  const textObj = {
    expired: '已过期',
    unknown: '未知',
    failure: '交付失败',
    upgrade: '升级中',
    starting: '启动中',
    running: '运行中',
    preparing: '准备中',
    installing: '安装中',
    upgrading: '升级中',
    serving: '服务中',
    abnormal: '异常',
    closed: '已关闭',
    released: '已释放',
    stopping: '关闭中',
    release: '已释放',
    undeploy: '未部署'
  };

  const custom = colorType && colorType === 'time' ? '#606266' : '#009900';
  const colorObj = {
    preparing: '#009900',
    serving: custom,
    expired: '#F00000',
    installing: '#606266',
    upgrade: '#009900',
    running: custom
  };
  if (colorType) {
    return colorObj[state] || '#606266';
  }
  return textObj[state] || state;
}

export function handleServiceStatus(state, colorType) {
  const textObj = {
    failure: '交付失败',
    upgrade: '升级中',
    expired: '已过期',
    unknown: '未知',
    starting: '服务启动中',
    running: '正常服务中',
    preparing: '服务准备中',
    installing: '服务安装中',
    upgrading: '服务升级中',
    serving: '服务中',
    abnormal: '服务异常',
    closed: '已停止服务',
    stopping: '停止服务中',
    released: '已释放',
    release: '已释放',
    undeploy: '未部署'
  };

  const custom = colorType && colorType === 'time' ? '#606266' : '#009900';
  const colorObj = {
    preparing: '#009900',
    serving: custom,
    expired: '#F00000',
    installing: '#606266',
    running: custom
  };
  if (colorType) {
    return colorObj[state] || '#606266';
  }
  return textObj[state] || state;
}

/* 周期 */
export function handleCycle(state) {
  const textObj = {
    week: '周',
    month: '月',
    quarter: '季度',
    year: '年'
  };
  return textObj[state] || state;
}

/* 订单类型 */
export function handleOrderType(type) {
  const textObj = {
    new: '新购',
    renew: '续费',
    trail: '试用'
  };
  return textObj[type] || type;
}

export function showMessageStatus(status) {
  const textObj = {
    Start: '持续中',
    Silence: '沉默',
    Finish: '已结束'
  };
  return textObj[status] || status;
}
/* 应用状态 */
export function fetchEnterpriseAppStateOptions() {
  const mapObj = {
    preparing: '准备中',
    serving: '服务中',
    expired: '已过期'
  };
  const arr = [{
    label: '全部',
    value: ''
  }]
  Object.keys(mapObj).forEach((key) => {
    arr.push({
      label: mapObj[key],
      value: key
    })
  })
  return arr;
}

/* 应用状态 */
export function fetchDeliveryAppStateOptions() {
  const mapObj = {
    preparing: '准备中',
    installing: '安装中',
    starting: '启动中',
    running: '运行中',
    upgrading: '升级中',
    closed: '已关闭',
    stopping: '关闭中',
    released: '已释放',
    expired: '已过期',
    failure: '交付失败',
    unknown: '未知'
  };
  const arr = [{
    label: '全部',
    value: ''
  }]
  Object.keys(mapObj).forEach((key) => {
    arr.push({
      label: mapObj[key],
      value: key
    })
  })
  return arr;
}



// WEBPACK FOOTER //
// ./src/utils/dictionary.js